import { useState } from 'react';
import { cx } from '../lib/cx';

interface Props {
  /** Potpisani URL s API-ja. `null` = vježba nema sliku. */
  src: string | null;
  /** Ime vježbe — ide u `alt` samo kad slika stvarno postoji. */
  name: string;
  size?: 'sm' | 'md';
  className?: string;
}

const SIZE = {
  sm: 'h-11 w-11',
  md: 'h-14 w-14',
} as const;

/**
 * Sličica vježbe, s rezervnim znakom kad slike nema.
 *
 * Većina vježbi u biblioteci još nema fotografiju i dugo će je nemati, pa
 * rezervno stanje nije rub nego pravilo: umjesto prazne rupe stoji ploha u boji
 * podloge s inicijalom, da redak zadrži istu visinu i poravnanje.
 *
 * Potpisani URL može isteći ili slika nestati iz R2 — `onError` tada vraća isti
 * rezervni prikaz umjesto slomljene ikone preglednika.
 */
export function ExerciseThumb({ src, name, size = 'sm', className }: Props) {
  const [failed, setFailed] = useState(false);
  const box = cx(
    SIZE[size],
    'shrink-0 overflow-hidden rounded-lg border border-line-subtle',
    className,
  );

  if (!src || failed) {
    return (
      <span className={cx(box, 'flex items-center justify-center bg-bg-alt')} aria-hidden="true">
        <span className="font-display text-[15px] text-ink-muted">{name.slice(0, 1)}</span>
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
      className={cx(box, 'block object-cover')}
    />
  );
}
